import React, { useState, useContext, useEffect } from 'react'
import moment from 'moment'
import axios from 'axios'
import { KeyboardDatePicker, KeyboardDateTimePicker } from '@material-ui/pickers'
import CustomSelect from '../../product/components/atoms/Inputs/CustomSelect'
import CustomMultiSelect from '../../product/components/atoms/Inputs/CustomMultiSelect'
import MenuItem from '@material-ui/core/MenuItem'
import CustomInput from '../../product/components/atoms/Inputs/CustomInput'
import CustomPhone from '../../product/components/atoms/Inputs/CustomPhone.js'
import CheckBox from '../../product/components/atoms/CheckBox'
import CustomTextArea from '../../product/components/atoms/Inputs/CustomTextArea'
import CKEditor from 'ckeditor4-react'
import { socket } from '../../product/common/socket'

// import { CKEditor } from '@ckeditor/ckeditor5-react'
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

export const MOCK_NEWS_DATA = {
    responseType: 1,
    message: 'Successfully retrived',
    responseData: {
        records: {
            obj: [
                {
                    id: '34961',
                    type: 'artist',
                    subType: 'chart',
                    formattedDate: '2025-10-02',
                    imageUrl: 'https://i.scdn.co/image/7d61c443d3687d417f1ca51ef67cc6781f985730',
                    summaryTemplate: ':trackName  added to the :chartName, ranking at #10.',
                    summaryData: {
                        chartName: 'Deezer Ecuador Chart',
                        trackName: 'me puedo matar',
                    },
                    metadata: {
                        chartUrlParam: 'deezer?country=ec&date=2025-10-02',
                        cmTrackId: 24907221,
                        artistName: 'Héctor Acosta "El Torito"',
                        cmArtistId: 207327,
                    },
                    stars: 3,
                },
                {
                    id: '34962',
                    type: 'artist',
                    subType: 'chart',
                    formattedDate: '2025-10-02',
                    imageUrl: 'https://i.scdn.co/image/7d61c443d3687d417f1ca51ef67cc6781f985730',
                    summaryTemplate: ':trackName  added to the :chartName, ranking at #10.',
                    summaryData: {
                        chartName: 'Deezer Ecuador Chart',
                        trackName: 'me puedo matar',
                    },
                    metadata: {
                        chartUrlParam: 'deezer?country=ec&date=2025-10-02',
                        cmTrackId: 24907221,
                        artistName: 'Héctor Acosta "El Torito"',
                        cmArtistId: 207327,
                    },
                    stars: 3,
                },
                {
                    id: '34963',
                    type: 'artist',
                    subType: 'chart',
                    formattedDate: '2025-09-16',
                    imageUrl: 'https://i.scdn.co/image/eba2c61a2a9e2f62cac306c4b12df70de7384219',
                    summaryTemplate: ':trackName  added to the :chartName, ranking at #29.',
                    summaryData: {
                        chartName: 'iTunes Sweden Latino Chart',
                        trackName: 'Amorcito Enfermito',
                    },
                    metadata: {
                        chartUrlParam: 'itunes?country=se&genre=Latino&date=2025-09-16',
                        cmTrackId: 13795049,
                        artistName: 'Héctor Acosta "El Torito"',
                        cmArtistId: 207327,
                    },
                    stars: 3,
                },
                {
                    id: '34964',
                    type: 'artist',
                    subType: 'chart',
                    formattedDate: '2025-09-16',
                    imageUrl: 'https://i.scdn.co/image/179e7cc61098977862078c01b9bd62ba71c2a8da',
                    summaryTemplate: ':trackName  added to the :chartName, ranking at #34.',
                    summaryData: {
                        chartName: 'iTunes Sweden Latino Chart',
                        trackName: 'O Te Vas o Me Voy',
                    },
                    metadata: {
                        chartUrlParam: 'itunes?country=se&genre=Latino&date=2025-09-16',
                        cmTrackId: 13795050,
                        artistName: 'Héctor Acosta "El Torito"',
                        cmArtistId: 207327,
                    },
                    stars: 3,
                },
                {
                    id: '34965',
                    type: 'artist',
                    subType: 'chart',
                    formattedDate: '2025-09-16',
                    imageUrl: 'https://i.scdn.co/image/2d4063c28eb0ed3896a4a5eb10d780f7e2514009',
                    summaryTemplate: ':trackName  added to the :chartName, ranking at #44.',
                    summaryData: {
                        chartName: 'iTunes Sweden Latino Chart',
                        trackName: 'éramos niños',
                    },
                    metadata: {
                        chartUrlParam: 'itunes?country=se&genre=Latino&date=2025-09-16',
                        cmTrackId: 14290659,
                        artistName: 'Héctor Acosta "El Torito"',
                        cmArtistId: 207327,
                    },
                    stars: 3,
                },
                {
                    id: '34966',
                    type: 'artist',
                    subType: 'chart',
                    formattedDate: '2025-09-13',
                    imageUrl: 'https://i.scdn.co/image/32d5089f38e885b44042cfd6769cddd52672a33f',
                    summaryTemplate: ':trackName  added to the :chartName, ranking at #6.',
                    summaryData: {
                        chartName: 'iTunes Dominican Republic All Genres Chart',
                        trackName: 'Loca Conmigo (En Vivo Hotel Jaragua Santo Domingo Rd)',
                    },
                    metadata: {
                        chartUrlParam: 'itunes?country=do&genre=All Genres&date=2025-09-13',
                        cmTrackId: 26182133,
                        artistName: 'Héctor Acosta "El Torito"',
                        cmArtistId: 207327,
                    },
                    stars: 3,
                },
                {
                    id: '34967',
                    type: 'artist',
                    subType: 'track',
                    formattedDate: '2025-09-13',
                    imageUrl: 'https://i.scdn.co/image/ab67616d0000b273ded52832f602bb48fe8fd1b7',
                    summaryTemplate: ':trackName reached 250K streams on Pandora.',
                    summaryData: {
                        trackName: 'Si No Me Falla El Corazón',
                    },
                    metadata: {
                        cmTrackId: 147554242,
                        artistName: 'Héctor Acosta "El Torito"',
                        cmArtistId: 207327,
                    },
                    stars: 3,
                },
                {
                    id: '34968',
                    type: 'artist',
                    subType: 'chart',
                    formattedDate: '2025-09-12',
                    imageUrl: 'https://i.scdn.co/image/ab67616d0000b273ca11565465dbe34008911a23',
                    summaryTemplate: ':trackName  added to the :chartName, ranking at #3.',
                    summaryData: {
                        chartName: 'iTunes Finland Latino Chart',
                        trackName: "Pa' Que Me Perdones",
                    },
                    metadata: {
                        chartUrlParam: 'itunes?country=fi&genre=Latino&date=2025-09-12',
                        cmTrackId: 46964796,
                        artistName: 'Héctor Acosta "El Torito"',
                        cmArtistId: 207327,
                    },
                    stars: 5,
                },
                {
                    id: '34969',
                    type: 'artist',
                    subType: 'chart',
                    formattedDate: '2025-09-10',
                    imageUrl: 'https://i.scdn.co/image/9c72d68365325e54e96b7c87555e3b89db13a805',
                    summaryTemplate: ':trackName  added to the :chartName, ranking at #2.',
                    summaryData: {
                        chartName: 'iTunes Finland Latino Chart',
                        trackName: 'Me Duele la Cabeza',
                    },
                    metadata: {
                        chartUrlParam: 'itunes?country=fi&genre=Latino&date=2025-09-10',
                        cmTrackId: 13795031,
                        artistName: 'Héctor Acosta "El Torito"',
                        cmArtistId: 207327,
                    },
                    stars: 5,
                },
                {
                    id: '34970',
                    type: 'artist',
                    subType: 'chart',
                    formattedDate: '2025-09-10',
                    imageUrl: 'https://i.scdn.co/image/35e732789c970ca60907c39b219fd2de5cd11380',
                    summaryTemplate: ':trackName  added to the :chartName, ranking at #4.',
                    summaryData: {
                        chartName: 'iTunes Finland Latino Chart',
                        trackName: 'Primavera Azul',
                    },
                    metadata: {
                        chartUrlParam: 'itunes?country=fi&genre=Latino&date=2025-09-10',
                        cmTrackId: 13795025,
                        artistName: 'Héctor Acosta "El Torito"',
                        cmArtistId: 207327,
                    },
                    stars: 5,
                },
            ],
        },
    },
}

let serverTime = new Date()
const dateFormat = 'MM-DD-YYYY'
const dateTimeFormat = 'MM-DD-YYYY h:mm a'

export const FORMATS = {
    MMM_DD_YYYY: 'MMM Do YYYY',
    MMM_DD_YYYY_COMMA: 'MMM Do, YYYY',
    YYYY_MM_DD: 'YYYY-MM-DD',
    FULL_DATE: 'dddd, MMMM Do YYYY',
}

if (socket) {
    socket.on('sliservertime', (data) => {
        if (moment(data.dTime).isValid()) {
            serverTime = new Date(data.dTime)
        }
    })
}

export const handleRedirectInternal = (history, path) => {
    history.push(`/${path}`)
    window.scrollTo(0, 0)
}
export const dateFormatFront = (data) => {
    return moment(data).isValid()
        ? `${moment(data).format('MMM Do')}, ${moment(data).format('h:mm a')}`
        : '-'
}

export const capitalize = (data) => {
    return data ? data.charAt(0).toUpperCase() + data.slice(1) : '-'
}

export const dateFormatFrontDay = (data, format = FORMATS.MMM_DD_YYYY) => {
    return `${moment(data).format(format)}`
}

export const currencyFormat = (data) => {
    return `$${parseFloat(data).toFixed(2).toLocaleString('en-US')}`
}

export const numberFormatPositive = (data) => {
    return `${data < 0 ? 0 : data}`
}

export const currencyFormatInt = (data) => {
    return `${
        parseInt(data).toLocaleString('en-US') !== 'NaN'
            ? '$' + data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            : ''
    }`
}

export const currencyFormatFloat = (data) => {
    return `${
        parseFloat(parseFloat(data).toFixed(2)).toLocaleString('en-US') !== 'NaN'
            ? '$' +
              parseFloat(data)
                  .toFixed(2)
                  .toLocaleString('en-US')
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            : ''
    }`
}

export const currencyFormatTwo = (data) => {
    return `${new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    }).format(data)}`
}

export const currencyFormatTwoNoDollar = (data) => {
    return `${parseFloat(parseFloat(data)).toFixed(2).toLocaleString('en-US')}`
}

export const numberFormat = (data) => {
    return `${
        parseFloat(parseFloat(data).toFixed(2)).toLocaleString('en-US') !== 'NaN'
            ? parseFloat(parseFloat(data).toFixed(2)).toLocaleString('en-US')
            : ''
    }`
}

export const numberFormatCommaSeparate = (data) => {
    return `${
        parseFloat(parseFloat(data).toFixed(2)).toLocaleString('en-US') !== 'NaN'
            ? data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            : ''
    }`
}

export const checkProductOpen = (date_added, user_role) => {
    let startDate = new Date(serverTime)
    let addDate = new Date(date_added)
    let milliSeconds = 0
    // if (parseInt(user_role) !== 3) {
    //   milliSeconds = 1 * 3600000;
    // } else {
    // }
    let incrementedTime = addDate.getTime() + parseInt(milliSeconds)
    let newaddDate = new Date(incrementedTime)
    if (newaddDate > startDate) {
        return false
        // let incrementedTime = addDate.getTime() + parseInt(milliSeconds);
        // let timerTime = incrementedTime - startDate.getTime();
        // if (timerTime <= 0) {
        //   return true;
        // } else {
        //   return false;
        // }
    } else {
        return true
    }
}

export const maskEmailFront = (data) => {
    data = data.toString()
    var first4 = data.substring(0, 4)
    var last5 = data.substring(data.length - 5)
    var mask = data.substring(4, data.length - 5).replace(/[^]/g, '*')
    return first4 + mask + last5
}

export const dateFormatFrontOnlyDate = (data) => {
    return `${moment(data).format(dateFormat)}`
}

export const dateTimeFormatFunction = (data) => {
    return `${moment(data).format(dateTimeFormat)}`
}

export const DirectAPICAll = (method, url) => {
    return new Promise(async (resolve, reject) => {
        try {
            if (method === 'get') {
                let res = await axios.get(`${url}`)
                resolve(res)
            } else if (method === 'post') {
                let res = await axios.post(`${url}`)
                resolve(res)
            }
        } catch (err) {
            console.log('responsode error from api', err)
            resolve(err)
        }
    })
}

export const useCustomMediaQuery = (queryString) => {
    const [isMatch, setIsMatch] = useState(false)
    const mqChange = (mq) => {
        setIsMatch(mq.matches)
    }

    useEffect(() => {
        const mq = window.matchMedia(queryString)
        mq.addListener(mqChange)
        mqChange(mq)

        return () => {
            mq.removeListener(mqChange)
        }
    }, [queryString])

    return isMatch
}

export function capitalizeFirstLetter(str) {
    if (!str) return ''
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
}

export function formatNumber(num, placeHolder = '-') {
    if (num >= 1_000_000_000) {
        return (num / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + 'B'
    } else if (num >= 1_000_000) {
        return (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M'
    } else if (num >= 1_000) {
        return (num / 1_000).toFixed(1).replace(/\.0$/, '') + 'K'
    } else {
        return num?.toString() ?? placeHolder
    }
}
